import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import UnauthorizedLayoutService from '~local/app/layout/unauthorized-layout/unauthorized-layout.service';

export type EntryStatus = {
    registrationEnabled: boolean;
    registrationDisabledReason: string;
    invitationEnabled: boolean;
    regionRestricted: boolean;
}

@Injectable({
    providedIn: 'root'
})
export default class EntryService {
    private readonly httpClient = inject(HttpClient);
    private readonly simpleLayoutService = inject(UnauthorizedLayoutService);

    private _data: EntryStatus | null = null;

    public checkIpAddressStatus(): Observable<EntryStatus> {
        this.simpleLayoutService.loading$.next(true);
        return this.httpClient.get<EntryStatus>('/status')
            .pipe(
                tap($ => {
                    this.simpleLayoutService.loading$.next(false);
                    this._data = $
                }),
                catchError(() => {
                    this.simpleLayoutService.loading$.next(false);
                    this._data = null
                    return of(null)
                })
            )
    }

    get data(): EntryStatus | null {
        return this._data;
    }
}
